<template>
  <v-dialog :value="true" v-if="visible" persistent max-width="400">
    <v-card>
      <v-card-title>
        <span class="title-modal">Erro</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="error" color="#e72c1f">{{ errorText }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1 text-right">
          <v-btn class="btn-cancel" @click.prevent="$emit('cleanError')">Voltar</v-btn>
        </div>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
<script>
export default {
  name: 'generic-error-dialog',
  props: {
    cleanError: {},
    errorText: {},
    visible: {}
  }
}
</script>
<style scoped>

.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

.qrcode .steps p {
  margin: unset;
}

.qrcode span {
  font-size: 16px;
  color: #3f3f3f;
  margin: unset;
}

@media only screen and (max-width: 500px) {

  .v-stepper__content button {
    width: 100%;
    margin: 5px 0;
  }

}
</style>
